var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rating',{attrs:{"readonly":"","value":_vm.value,"full-icon":"mdi-circle","empty-icon":"mdi-circle-outline","length":"5","color":"white","background-color":"white","size":"15px"}})}
var staticRenderFns = []

export { render, staticRenderFns }